import { jsx as l, jsxs as Z } from "react/jsx-runtime";
import { forwardRef as z, useState as f, useRef as S, useEffect as w, useMemo as F, useCallback as G, useImperativeHandle as J } from "react";
import { createPortal as O } from "react-dom";
import { createRoot as Q } from "react-dom/client";
import i from "./styles.module.less.js";
import { useDisableScroll as X } from "../../../utils/use-disable-scroll.js";
const V = "user-info-atticus", j = z(
  ({
    defaultOpen: g = !1,
    onClose: d,
    onOpen: o,
    iframeUrl: s,
    category: a = null,
    suburb: m = null,
    suburbUrl: p = null,
    utmContent: y,
    fromFirm: h,
    additionalParams: n = {},
    ga4MeasurementId: r,
    onIframeLoad: I,
    user: C
  }, k) => {
    const [v, N] = f(g), [L, R] = f(!1), [_, D] = f(!1), [M, q] = f(""), [b, U] = f(""), T = S(null), c = S(null), $ = S(""), [x, W] = f(!1);
    X({ isDisabled: v }), w(() => {
      (() => {
        if (typeof window < "u" && window.gtag)
          try {
            if (r) {
              window.gtag(
                "get",
                r,
                "client_id",
                (e) => {
                  e && q(e);
                }
              ), window.gtag(
                "get",
                r,
                "session_id",
                (e) => {
                  e && U(e);
                }
              );
              return;
            }
          } catch (e) {
            console.warn("Failed to get GA4 data from gtag:", e);
          }
      })();
    }, [r]);
    const A = F(() => {
      const t = new URLSearchParams();
      Object.entries(n).forEach(([u, Y]) => {
        u !== "client_id" && u !== "session_id" && t.append(u, Y);
      }), M && t.append("client_id", M), b && t.append("session_id", b);
      const e = t.toString();
      return `${s}${e ? `?${e}` : ""}`;
    }, [s, n, M, b]);
    w(() => {
      A !== $.current && D(!1), $.current = A;
    }, [A]);
    const H = G(() => {
      c.current && (clearTimeout(c.current), c.current = null), R(!1), N(!0), o == null || o();
    }, [o]), E = G(() => {
      c.current && clearTimeout(c.current), R(!0), c.current = setTimeout(() => {
        N(!1), R(!1), d == null || d();
      }, 200);
    }, [d]);
    w(() => () => {
      c.current && clearTimeout(c.current);
    }, []);
    const K = () => {
      D(!0), I == null || I();
    };
    w(() => {
      v && _ && setTimeout(() => {
        var t;
        if (T.current) {
          const e = {
            type: "init-atticus",
            payload: {
              category: a || null,
              suburb: p || m || null,
              ...h ? { fromFirm: h } : {},
              utm: {
                utmSource: n.utm_source || void 0,
                utmContent: y || void 0,
                utmCampaign: n.utm_campaign || void 0,
                utmMedium: n.utm_medium || void 0,
                utmTerm: n.utm_term || a || void 0,
                gclid: n.gclid || void 0,
                gaClientId: M || void 0
              },
              source: "lawconnect",
              sourceUrl: window.location.href,
              // Include all stored query string parameters
              queryParams: n
            }
          };
          try {
            W(!0), (t = T.current.contentWindow) == null || t.postMessage(e, "*");
          } catch (u) {
            console.error("❌ Error sending postMessage:", u);
          }
        }
      }, 100);
    }, [
      v,
      _,
      a,
      m,
      p,
      y,
      h,
      n
    ]);
    const B = S(!1);
    return w(() => {
      var t, e;
      if (x && C && !B.current) {
        B.current = !0;
        const u = {
          type: V,
          name: C.name,
          email: C.email,
          phone: C.phone
        };
        (e = (t = T.current) == null ? void 0 : t.contentWindow) == null || e.postMessage(u, "*");
      }
    }, [x, C]), J(k, () => ({
      openModal: H,
      closeModal: E
    })), !v && !L ? null : O(
      /* @__PURE__ */ l(
        "div",
        {
          className: `${i.modal} ${L ? i.closing : ""}`,
          onClick: E,
          children: /* @__PURE__ */ Z(
            "div",
            {
              className: `${i.modalContent} ${L ? i.closing : ""}`,
              onClick: (t) => t.stopPropagation(),
              children: [
                /* @__PURE__ */ l("div", { className: i.close, onClick: E, children: /* @__PURE__ */ l(
                  "svg",
                  {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /* @__PURE__ */ l(
                      "path",
                      {
                        d: "M19.5 3.75C19.9142 3.75 20.25 4.08579 20.25 4.5C20.25 4.70708 20.1661 4.89456 20.0304 5.03028L13.0607 12L20.0304 18.9696C20.1661 19.1054 20.25 19.2929 20.25 19.5C20.25 19.9142 19.9142 20.25 19.5 20.25C19.2894 20.25 19.099 20.1632 18.9628 20.0233L12.0001 13.0606L5.03039 20.0303C4.89466 20.166 4.70713 20.25 4.5 20.25C4.08579 20.25 3.75 19.9142 3.75 19.5C3.75 19.2912 3.83535 19.1023 3.97308 18.9663L10.9394 12L3.97671 5.03727C3.83685 4.90104 3.75 4.71066 3.75 4.5C3.75 4.08579 4.08579 3.75 4.5 3.75C4.70711 3.75 4.89462 3.83395 5.03034 3.96968L12.0001 10.9393L18.9663 3.97308C19.1023 3.83535 19.2912 3.75 19.5 3.75Z",
                        fill: "#B0B7BD"
                      }
                    )
                  }
                ) }),
                !_ && /* @__PURE__ */ l("div", { className: i.loadingSpinner, children: /* @__PURE__ */ l("div", { className: i.spinner }) }),
                /* @__PURE__ */ l(
                  "iframe",
                  {
                    ref: T,
                    src: A,
                    width: "100%",
                    height: "100%",
                    onLoad: K,
                    className: i.iframe,
                    title: "Atticus AI Assistant",
                    style: { opacity: _ ? 1 : 0 }
                  }
                )
              ]
            }
          )
        }
      ),
      document.body
    );
  }
);
j.displayName = "AtticusModal";
const se = (g, d = !1) => {
  const o = document.createElement("div");
  document.body.appendChild(o);
  const s = { current: null };
  let a = !1;
  const m = Q(o), p = () => {
    a && s.current ? s.current.openModal() : setTimeout(() => p(), 0);
  }, y = () => {
    a && s.current && s.current.closeModal();
  }, h = () => {
    if (s.current)
      s.current.closeModal(), setTimeout(() => {
        try {
          m.unmount(), document.body.contains(o) && document.body.removeChild(o);
        } catch (r) {
          console.error("Error destroying modal:", r);
        }
      }, 300);
    else
      try {
        m.unmount(), document.body.contains(o) && document.body.removeChild(o);
      } catch (r) {
        console.error("Error destroying modal:", r);
      }
  }, n = {
    ...g,
    defaultOpen: d,
    // Set defaultOpen based on immediate flag
    ref: (r) => {
      r && (s.current = r, a = !0);
    },
    // Ensure we properly handle the onClose event
    onClose: () => {
      g.onClose && g.onClose();
    }
  };
  return m.render(/* @__PURE__ */ l(j, { ...n })), {
    open: p,
    close: y,
    destroy: h
  };
};
export {
  j as AtticusModal,
  se as createAtticusModal
};
